module.exports = __webpack_public_path__ + "img/04.ef2426ca.jpg";